<template>
  <main id="main">
    <Loading :isProcessing="isProcessing"></Loading>
    <DiagCorpHeader
      v-if="!isRendering"
      :corpName="corpName"
      :corporateFeatureInfoLabels="corporateFeatureInfoLabels"
      :corporateSelectable="isAdmin"
      :manageCorpName="manageCorpName"
      :isAdmin="isAdmin"
      :isDiagAvailablePlan="isDiagAvailablePlan"
      @select-corporate="emitSelectCorpList"
    ></DiagCorpHeader>
    <div class="l-contents" v-if="!isRendering">
      <h1 class="l-pageTitle"><img src="@/assets/img/common/icon-nav2_blue.svg" alt="">小テスト</h1>
      <p class="l-text">注意が必要な法令改正や、話題の労務トラブルをテーマにしたチェックシートを配信しています。<br>
        トラブルを未然に回避するため、積極的に活用してください。<br>
        チェックするだけでなく、達成率100点を目指してがんばりましょう！</p>
      <ul class="l-minList">
        <li class="l-minList__item" v-for="(roughDiagResult, index) in roughDiagResultHistory" :key="index" :class="{ 'is-complete' : roughDiagResult.isAchieved}">
          <a>
            <div class="l-minList__img" @click="goRoughDiagAnswer(roughDiagResult.roughDiagId)">
              <span class="info-newlabel" v-if="roughDiagResult.isNew">NEW</span>
              <img src="@/assets/img/min/default.png" alt="">
            </div>
            <p class="l-minList__title">{{ roughDiagResult.title }}</p>
            <p class="l-minList__text">{{ roughDiagResult.description }}</p>
            <div class="l-minList__progress">
              <div class="flag"><span></span></div>
              <div class="response">
                <p class="number">{{ roughDiagResult.achievedItemCount }}/{{ roughDiagResult.totalCount }}</p>
                <div class="progress_bar"><span :style="('width: ' + roughDiagResult.progress + '%')"></span></div>
              </div>
            </div>
          </a>
        </li>
      </ul>
    </div>
  </main>
</template>

<script>
import Loading from '@/components/parts/common/Loading.vue';
import DiagCorpHeader from '@/components/parts/diag/DiagCorpHeader.vue';

export default {
  components: {
    Loading,
    DiagCorpHeader,
  },
  data() {
    return {
      isProcessing: false,
      roughDiagResultHistory: [],
      isRendering: false,
      isAdmin: false,
      isDiagAvailablePlan: false,
    }
  },
  computed: {
    corpId: function () {
      return this.$store.getters['diag/getCorpId'];
    },
    corpName() {
      return this.$store.getters['diag/getCorpName'];
    },
    corporateFeatureInfoLabels() {
      return this.$store.getters['diag/getCorporateFeatureInfoLabels'];
    },
    manageCorpName() {
      return this.$store.getters['auth/getUser'].manageCorpNm;
    },
  },
  watch: {
    async corpId() {
      this.isRendering = true;
      this.isProcessing = true;

      await this.getRoughDiagResultHistory(this.corpId);
      await this.getCorporateFeatureInfoLabels(this.corpId);
      this.$nextTick(() => {
        this.isRendering = false;
        this.isProcessing = false;
      });
    }
  },
  created: async function () {
    this.isRendering = true;
    this.isProcessing = true;

    await this.getRoughDiagResultHistory(this.corpId);
    await this.getDataForParamAccess(this.corpId);

    const authority = await this.$store.dispatch('auth/getAuthority')
    this.isAdmin = authority.isAdmin;
    this.isDiagAvailablePlan = authority.isDiagAvailablePlan;
    this.$nextTick(() => {
      this.isRendering = false;
      this.isProcessing = false;
    });
  },
  methods: {
    async getRoughDiagResultHistory(corpId) {
      let res = await this.$axios.post('/ld/api/diag/roughDiag/getRoughDiagResultHistory', {
        corpId: corpId,
      });
      if (res) {
        this.roughDiagResultHistory = res.data.roughDiagResultHistory;
      }
    },
    async getCorporateFeatureInfoLabels(corpId) {
      let res = await this.$axios.post('/ld/api/corporate/getCorporateFeatureInfoLabels', {
        corpId: corpId,
      });
      if (res) {
        this.$store.dispatch('diag/setCorporateFeatureInfoLabels', res.data.corporateFeatureInfoLabels);
      }
    },
    async getDataForParamAccess(corpId) {
      if (corpId) {
        this.isProcessing = true;
        let res = await this.$axios.post('/ld/api/diag/roughDiag/getDataForParamAccess', {
          corpId: corpId,
          diagResultId: null,
        });
        if (res.status==200) {
          this.$store.dispatch('diag/setCorporateFeatureInfoLabels', res.data.corporateFeatureInfoLabels);
          this.$store.dispatch('diag/setCorpName', res.data.corpNm);
        }
        this.isProcessing = false;
      }
    },
    goRoughDiagAnswer(roughDiagId) {
      this.$store.dispatch('diag/setRoughDiagId', roughDiagId);
      this.$router.replace({path: '/rough_diag/'+this.corpId+'/'+roughDiagId+'/answerparam'});
    },
    emitSelectCorpList(params) {
      this.$store.dispatch('diag/setCorpId', params.corpId);
      this.$store.dispatch('diag/setCorpName', params.corpNm);
      // 法人切替後は以下情報をリセットする
      this.$store.dispatch('diag/setDiagResultId', null);
      this.$store.dispatch('diag/setDiagResultItemId', null);
    },
  }
}
</script>
